import { Component, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error?: Error
}

/**
 * 捕获子组件渲染与懒加载失败的错误边界
 * @param props - 子节点
 * @returns 包裹后的节点或错误 UI
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    // 可接入日志上报
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-900'>
          <div className='w-[min(92vw,520px)] rounded-lg shadow-md bg-white dark:bg-gray-800 p-6 space-y-3'>
            <h2 className='text-lg font-semibold text-red-600'>页面加载失败</h2>
            <p className='text-sm text-gray-700 dark:text-gray-300 wrap-break-word'>{this.state.error?.message || '未知错误'}</p>
            <button type='button' className='px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md' onClick={this.handleRetry}>
              重试
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
